import React from "react";

const LeftHover = () => (
  <div className="tooltip tooltip--left-view">
    <p className="tooltip__text" />
  </div>
);

export default LeftHover;
